<div
  class="main-menu__item"
  *ngFor="let menuItem of menuItems; index as i"
  (click)="onOpenSubMenu(i)"
>
  <app-menu-link
    styleClass="main-link"
    [item]="menuItem"
    [isActive]="activeSectionId === menuItem.id"
  ></app-menu-link>

  <span
    *ngIf="menuItem.countMark"
    class="main-menu__count-mark"
    [ngClass]="menuItem.countMarkStyleClass"
    [title]="menuItem.countMarkLabel ? menuItem.countMarkLabel : ''"
    >{{ menuItem.countMark }}</span
  >

  <span
    class="main-menu__tooltip-icon"
    tooltipPosition="bottom"
    [pTooltip]="menuItem.tooltip"
    *ngIf="menuItem.tooltip"
  >
  </span>
</div>
